export default __webpack_public_path__ + "static/media/service-3.04edeb62.jpg";